export class InvalidParametersError extends Error {
  static name = 'InvalidParametersError'
  name = 'InvalidParametersError'
}

export class DecryptionFailedError extends Error {
  static name = 'DecryptionFailedError'
  name = 'DecryptionFailedError'
}
